// Skeleton loading placeholders (new design system).
// Styling lives in assets/css/app.css (.skeleton / .skeleton-* utilities).
//
//   <Skeleton width={120} />                     one line
//   <Skeleton variant="block" height={80} />     a filled block
//   <Skeleton variant="circle" width={36} height={36} />
//   <SkeletonRows count={6} />                    avatar + two lines, table-style rows

export default function Skeleton({ variant = "text", width, height, radius, className = "", style = {} }) {
  const variantClass =
    variant === "block" ? "skeleton-block" :
    variant === "circle" ? "skeleton-circle" :
    variant === "line" ? "skeleton-line" :
    "skeleton-text";
  return (
    <span
      className={`skeleton ${variantClass} ${className}`.trim()}
      style={{
        ...(width != null ? { width: typeof width === "number" ? `${width}px` : width } : {}),
        ...(height != null ? { height: typeof height === "number" ? `${height}px` : height } : {}),
        ...(radius != null ? { borderRadius: typeof radius === "number" ? `${radius}px` : radius } : {}),
        display: "inline-block",
        ...style,
      }}
    />
  );
}

// A stack of "row" skeletons matching the attendance-log / member-list layout:
// a circular avatar next to two text lines.
export function SkeletonRows({ count = 5, className = "" }) {
  return (
    <div className={className} aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div className="skeleton-row" key={i}>
          <span className="skeleton skeleton-circle" />
          <span className="sk-lines">
            <span className="skeleton skeleton-text" style={{ width: "45%" }} />
            <span className="skeleton skeleton-text" style={{ width: "70%" }} />
          </span>
        </div>
      ))}
    </div>
  );
}
